import React, { useEffect, useState } from 'react'
import CustomerDropdown from 'components/Dropdown/CustomerDropdown';
import InvoiceSearch from 'components/Inputs/InvoiceSearch';
import { NavLink, Outlet } from 'react-router-dom';
import AdminFooter from './AdminFooter';
import { useAuth } from 'hooks/AuthProvider';
import AdminSidebar from './AdminSidebar';

const AdminLayout = () => {
    const { currentUser, token, logout } = useAuth();
    const [sidebarType, setSidebarType] = useState();
    const [showProfile, setShowProfile] = useState();

    useEffect(() => {
        if (!token) { logout(); }
    }, [])

    const toggleSidebar = () => {
        if (sidebarType === "sidebar_minimize")
            setSidebarType("");
        else
            setSidebarType("sidebar_minimize");
    }

    const toggleProfile = () => {
        if (showProfile === "show")
            setShowProfile("");
        else
            setShowProfile("show");
    }

    return (
        <div className={`wrapper ${sidebarType}`}>
            <AdminSidebar logout={logout} toggleSidebar={toggleSidebar} />
            <div className="main-panel">
                <div className="main-header">
                    <div className="main-header-logo">
                        <div className="logo-header" data-background-color="dark">
                            <a href="index.html" className="logo">
                                <img
                                    src="assets/img/kaiadmin/logo_light.svg"
                                    alt="navbar brand"
                                    className="navbar-brand"
                                    height="20"
                                />
                            </a>
                            <div className="nav-toggle">
                                <button className="btn btn-toggle toggle-sidebar">
                                    <i className="gg-menu-right"></i>
                                </button>
                                <button className="btn btn-toggle sidenav-toggler">
                                    <i className="gg-menu-left"></i>
                                </button>
                            </div>
                            <button className="topbar-toggler more">
                                <i className="gg-more-vertical-alt"></i>
                            </button>
                        </div>
                    </div>
                    <nav className="navbar navbar-header navbar-header-transparent navbar-expand-lg border-bottom">
                        <div className="container-fluid">
                            <nav className="navbar navbar-header-left navbar-expand-lg navbar-form nav-search p-0 d-none d-lg-flex">
                                <CustomerDropdown className="form-control" />
                                <InvoiceSearch />
                            </nav>
                            <ul className="navbar-nav topbar-nav ms-md-auto align-items-center">
                                <li className="nav-item topbar-user dropdown hidden-caret">
                                    <div className="dropdown-toggle profile-pic hand" onClick={toggleProfile} aria-expanded="false">
                                        <div className="avatar-sm">
                                            <img src="/assets/img/profile.png" alt="..." className="avatar-img rounded-circle" />
                                        </div>
                                        <span className="profile-username">
                                            <span className="fw-bold">username</span>
                                        </span>
                                    </div>
                                    <ul className={`dropdown-menu dropdown-user animated fadeIn ${showProfile}`}>
                                        <div className="dropdown-user-scroll scrollbar-outer">
                                            <li>
                                                <div className="user-box">
                                                        <img
                                                            src="/assets/img/profile.png"
                                                            alt="image profile"
                                                            className="avatar-img rounded"
                                                        />
                                                    <div className="u-text">
                                                        <h4>{currentUser?.name}</h4>
                                                        <p className="text-muted">{currentUser?.role}</p>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="dropdown-divider"></div>
                                                <a className="dropdown-item" href="#">My Profile</a>
                                                <div className="dropdown-divider"></div>
                                                <NavLink to='/account/logout' className="dropdown-item" onClick={() => logout()}>Logout</NavLink>
                                            </li>
                                        </div>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
                <div className="container">
                    <div className="page-inner">
                        <Outlet />
                    </div>
                </div>
                <AdminFooter />
            </div>
        </div>
    )
}

export default AdminLayout;